"use client";

import { cn } from "@kyan/ui";
import { motion } from "motion/react";
import Image from "next/image";
import type { ReactNode } from "react";

import { useTopBannerFeatureFlag } from "#/hooks/featureFlags/useTopBannerFeatureFlag";
import { useShowTradePanel } from "#/store/app/tradePanel/showTradePanel";

import { ContentWrapper } from "./components/ContentWrapper/ContentWrapper";
import { ToggleButton } from "./components/ToggleButton/ToggleButton";
import { getTradePanelTransition } from "./utils/getPanelTransition";

export const TradePanel: React.FC = () => {
  const { showTradePanel } = useShowTradePanel();
  const { showTopBanner } = useTopBannerFeatureFlag();
  return (
    <motion.aside
      initial={false}
      transition={getTradePanelTransition(showTradePanel)}
      animate={{
        x: showTradePanel ? "0%" : "calc(100% - 3.75rem)",
      }}
      className={cn(
        "border-divider bg-background fixed right-0 bottom-0 my-4 w-[352px] rounded-l-lg bg-contain shadow-[-4px_0px_20px_0px_rgba(201,201,201,0.50)] dark:border dark:border-r-0 dark:bg-neutral-900 dark:bg-[linear-gradient(180deg,rgba(0,0,0,0.00)0%,rgba(0,0,0,0.60)100%),url('/images/common/texture.png')] dark:shadow-none dark:backdrop-blur-xs",
        {
          "h-[calc(100%-7rem)]": !showTopBanner,
          "h-[calc(100%-11.5rem)]": showTopBanner,
        },
      )}
    >
      <Image
        alt=""
        height={89}
        width={354}
        src="/images/components/trade-panel-gradient-border.svg"
        className="absolute -top-px -left-px z-[-1] hidden dark:inline"
      />
      <ToggleButton />
      <ContentWrapper />
    </motion.aside>
  );
};

export interface TradePanelWrapperProps {
  height?: number;
  children: ReactNode;
  className?: string;
}

export const TradePanelAreaLimiter: React.FC<TradePanelWrapperProps> = ({
  height,
  children,
  className,
}) => {
  const { showTradePanel } = useShowTradePanel();

  return (
    <motion.div
      initial={false}
      transition={getTradePanelTransition(showTradePanel)}
      className={cn("flex flex-col overflow-hidden", className)}
      style={{
        height: height ? `${height}px` : "100%",
      }}
      animate={{
        width: showTradePanel ? "calc(100% - 22rem)" : "calc(100% - 3.75rem)",
      }}
    >
      {children}
    </motion.div>
  );
};
